<template>
    <div class="page m-trainPlan">
        <!--<h3 class="page-title">培训计划</h3>-->
        <div class="btn-group">
            <button :class="{'active': !isFinished}" @click="isFinished = false">台账管理</button>
            <button :class="{'active': isFinished}" @click="isFinished = true">学情管理</button>
        </div>

        <component
            :is="componentName"
        ></component>


    </div>
</template>

<script>
    import api from '@/api';
    import {Ticket} from '@/utils';
    import selectMultiple from '@/components/Selectmultiple';
    import config from '@/config'
    import qs from 'qs'
    import ledgerManagement  from './Components/LedgerManagement'
    import studentsManagement  from './Components/StudentsManagement'
    export default {
        data() {
            return {
                userInfo: {},
                //删除相关
                isDeleteShow: false,
                //搜索条件相关
                formSearch: {
                    name: '',
                    types: [],
                    projectTypes: [],
                    forms: [],
                    years: [],
//                    forlevels: [],
                    trainer: '',
                    startTime: '',
                    endTime: ''
                },
                tableData: [],
                tableProps: {
                    border: false,
                    stripe: true,
                    rowKey: row => row.id,
                    height: "auto",
                },
                currentPage: 1,
                titles: [
                    {
                        prop: 'name',
                        label: this.$t('train.name'),
                        minWidth: '180px'
                    },
                    {
                        prop: 'typeName',
                        label: this.$t('train.type')
                    }, {
                        prop: 'projectTypeName',
                        label: '项目类别'
                    }, {
                        prop: 'formName',
                        label: this.$t('c.examType')
                    },{
                        prop: 'year',
                        label: this.$t('c.yearTime')
                    },{
                        prop: 'trainer',
                        label: '授课人员'
                    }, {
                        prop: 'numOfTrainees',
                        label: this.$t('train.memberNum')
                    }, {
                        prop: 'duration',
                        label: '实施时间',
                        width: '190px'
                    },
                ],
                selectNames: [{
                    key: "trainType",
                },
//                    {
//                    key: "trainMode",
//                },
                    {
                    key: "examForm",
                }, {
                    key: "projectType",
                }, {
                    key: "yearTime",
                }],
                selectPlanId: [],

                // 调研问卷相关
                isSurveyPaper: false,
                radio: undefined,
                surveySearch: {
                    name: undefined,
                },
                surveyPaperData: [],
                surveyTitles: [{
                    prop: 'name',
                    label: this.$t('train.surveyName')
                }, {
                    prop: 'createTime',
                    label: this.$t('c.creationTime')
                }, {
                    prop: 'creatorName',
                    label: this.$t('c.creator')
                }],
                currentPageDialog: 1,
                planID: undefined,
                templateID: undefined,
                isQRCode: false,
                qrValue: '',
                size: 180,
                selectedOrgName: '',
                orgID: '',
                qrCodeDialog: false,
                count: 0,
                expiry:'',
                dialogExtendTime:false,
                dialogForm:{
                    id:0,
                    name:'',
                    endTime:''
                },
                href: '',
                isFinished:false
            }
        },
        created() {
            if (Ticket.get()) {
                this.userInfo = Ticket.get();
            }
            this.getStandingBookData();
        },
        computed: {
            pickerOptions1() {
                let that = this;
                return {
                    disabledDate(time) {
                        if (!that.formSearch.endTime) return false;
                        return time.getTime() > new Date(that.formSearch.endTime).getTime()
                    },
                }
            },
            pickerOptions2() {
                let that = this;
                return {
                    disabledDate(time) {
                        if (!that.formSearch.startTime) return false;
                        return time.getTime() < new Date(that.formSearch.startTime).getTime()
                    },
                }
            },
            componentName() {
                if (this.isFinished) {
                    return 'studentsManagement';
                } else  {
                    return 'ledgerManagement';
                }
            },
        },
        methods: {
            getStandingBookData(page) {
                if(page) this.currentPage = page;
                let queryData = {...this.formSearch};

                ['types', 'forms', 'projectTypes','years'].forEach(v => {
                    if (this.formSearch[v].includes(0)) {
                        delete queryData[v];
                    }
                });
                api.queryStandingBook(queryData).then(res => {
                    let data = res.package;

                    for (let i = 0; i < data.length; i++) {
                        data[i].duration = data[i].startTime.substring(0, 10) + " — "
                            + (data[i].endTime && data[i].endTime.substring(0, 10) || '');
                        data[i].prePublishTime = data[i].prePublishTime?data[i].prePublishTime.substring(0, 16):'-';
                    }

                    this.tableData = data;
                })
            },

            deleteStandingBook() {
                this.$confirm(this.$t('m.delete'), this.$t('m.tip'), {
                    type: 'warning'
                }).then(() => {

                        api.deleteStandingBook({ids: this.selectPlanId}).then((data) => {
                            this.$message({
                                type: 'success',
                                message: this.$t('m.delSuccess')
                            });
                            this.getStandingBookData();
                            this.isDeleteShow = false;
                            this.$refs.trainTable.$refs.elTable.clearSelection();
                        });

                }).catch(() => {
                });
            },
            handleSelectionChange(val) {
                this.selectPlanId = [];
                val.forEach((v, k) => {
                    this.selectPlanId.push(v.id);
                });
                this.selectPlanId.length ? this.isDeleteShow = true : this.isDeleteShow = false;
            },
            checkboxInit(row) {
                return row.creatorId === this.userInfo.userID;
            },
            //搜索赋值
            getTrainTypeVal(data) {
                this.formSearch.types = data;
            },
            getExamFormVal(data) {
                this.formSearch.forms = data;
            },
            getProjectTypeVal(data) {
                this.formSearch.projectTypes = data;
            },
            getYearTimeVal(data) {
                this.formSearch.years = data;
            },
            //查看台账
            viewStandingBook(data) {
                this.$router.push({name: 'ledgerDetail', params: {ledgerId: data.id}})
            },
            //编辑台账
            editStandingBook(data) {
                this.$router.push({name: 'editLedger', params: {ledgerId: data.id}})
            },

            exportLedger() {
                const token = Ticket.get().access_token;
                const culture = this.$i18n.locale;

                let queryData = {
                    ...this.formSearch,
                    access_token: token
                };

                ['types', 'forms', 'projectTypes','years'].forEach(v => {
                    if (this.formSearch[v].includes(0)) {
                        delete queryData[v];
                    }
                });

                this.href = APIURI + 'api/Export/excel/standing-book?' + qs.stringify(queryData, {
                    indices: false
                });

                this.$nextTick(() => {
                    $('#export-a')[0].click();
                });
            },

            onSubpageClose() {
                if (Ticket.get()) this.getStandingBookData()
            }
        },
        components: {
            selectMultiple,
            ledgerManagement,
            studentsManagement
        }
    }
</script>

<style scoped lang="scss">
    @import '../../style/const.scss';
    .btn-group {
        margin-bottom: 20px;
        button {
            margin-right: 10px;
            padding: 8px 28px;
            outline: 0;
            color: #2f3238;
            background-color: #fff;
            border: 1px solid #fff;
            border-radius: 2px;
            cursor: pointer;

            &.active {
                background-color: $color-theme;
                color: #fff;
            }
        }
    }

    .m-trainPlan {
        .survey-paper {
            & /deep/ .el-table__body-wrapper{
                height: 300px;
            }
            & /deep/ .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
                box-shadow: none;
            }
        }
    }

</style>
